import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Headphones, Clock, Wrench, TrendingUp } from 'lucide-react'

const OdooSupport = () => {
  const features = [
    {
      icon: <Headphones className="w-6 h-6" data-component-path="client/src/pages/services/OdooSupport.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/OdooSupport.jsx:7:12" />,
      title: '24/7 Availability',
      description: 'Round-the-clock technical assistance'
    },
    {
      icon: <Clock className="w-6 h-6" data-component-path="client/src/pages/services/OdooSupport.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/OdooSupport.jsx:13:12" />,
      title: 'Fast Response',
      description: 'Priority support with quick resolution times'
    },
    {
      icon: <Wrench className="w-6 h-6" data-component-path="client/src/pages/services/OdooSupport.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/OdooSupport.jsx:19:12" />,
      title: 'Proactive Maintenance',
      description: 'Regular system health checks and updates'
    },
    {
      icon: <TrendingUp className="w-6 h-6" data-component-path="client/src/pages/services/OdooSupport.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/OdooSupport.jsx:25:12" />,
      title: 'Performance Monitoring',
      description: 'Continuous optimization for peak efficiency'
    },
  ]

  return (
    <ServiceTemplate
      title="Odoo Support & Maintenance"
      subtitle="24/7 expert support to keep your Odoo system running smoothly"
      description="Ensure maximum uptime and performance with our comprehensive Odoo support services. Our certified experts provide round-the-clock assistance, proactive maintenance, and rapid issue resolution to keep your business operations running without interruption."
      features={features}
      heroImage="https://images.pexels.com/photos/3825517/pexels-photo-3825517.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default OdooSupport